<mat-card class="ml-8 mr-8" appearance="filled">
  <mat-card-content>
    <ul class="breadcrumb">
      @for (breadcrumb of crumbs; track breadcrumb) {
        <li
          class="breadcrumb-item">
          @if (breadcrumb && breadcrumb.url) {
            <a [routerLink]="breadcrumb.url">{{breadcrumb.title}}</a>
          }
          @if (breadcrumb && !breadcrumb.url) {
            <span>{{breadcrumb.title}}</span>
          }
        </li>
      }
    </ul>
  </mat-card-content>
</mat-card>
